import type { Space } from '@mail/cross-sizes-utils';
import { Spacing, Text } from '@vkontakte/vkui';
import React from 'react';
import type { Product } from 'reactApp/types/Billing';
import { VkMusicRewardInfo } from 'reactApp/ui/VkMusicRewardInfo/VkMusicRewardInfo';
import { getPeriodName } from 'reactApp/utils/Period';

import styles from './VkMusicBlock.css';

interface VkMusicBlockProps {
    space: Space;
    accountLink?: string;
    product: Product;
    isReward: boolean;
}

export function VkMusicBlock({ space, product, isReward, accountLink }: VkMusicBlockProps) {
    const periodText = product?.period ? ` на\u00A0${getPeriodName(product.period, false, true)}` : '';
    return (
        <div className={styles.root}>
            <Text className={styles.header}>
                +{space?.value} и&nbsp;VK&nbsp;Музыка{periodText}
            </Text>
            <Spacing size={8} />
            <Text className={styles.subtitle}>Подписка активна</Text>
            <Spacing size={32} />
            {isReward && (
                <>
                    <VkMusicRewardInfo accountLink={accountLink} isMobile />
                    <Spacing size={8} />
                </>
            )}
        </div>
    );
}
